// SF-128 Component 0: shared pillar palette for nav-taxonomy surfaces (Sidebar, RealmHub,
// SiblingRow). Moved verbatim from Sidebar.tsx's former module-private SIDEBAR_PILLAR — a pure
// relocation, zero visual change. Distinct from the Warpath palette in pillarColors.ts
// (CLAUDE.md: "distinct sets, do not merge" — that rule is about not merging into pillarColors.ts,
// not about staying unexported forever).

export const NAV_PILLAR_COLORS = {
  economy: {
    primary: '#d4b85f',   // intentionally distinct from COLORS.gold (separate palette, SF-125)
    bgTint:  '#1e1c14',
  },
  military: {
    primary: '#c45a4a',   // terracotta/brick red
    bgTint:  '#1e1414',
  },
  science: {
    primary: '#6a9e8e',   // = COLORS.link (sage/teal)
    bgTint:  '#141e1a',
  },
  neutral: {
    primary: '#f0bd3c',   // sidebar-accent (fixed-dark, theme-independent — SF-125)
    bgTint:  '#1b2032',   // game-750
  },
} as const;

export type PillarKey = keyof typeof NAV_PILLAR_COLORS;
